/**
 * @module geo/actions/creators
 *
 */
import {promiseActionCreator} from '../../helpers/observable.to.promise';
import {ADD_TO_SELECTION, REMOVE_FROM_SELECTION, RESET_SELECTION} from '../../payload/facade';
import {Acknowledged} from '../../payload/response/acknowledged';
import {actionCreator} from '../helpers/actions.creator.builder';
import {ActionCreator} from '../helpers/fsa';
import {TypeKeyActions} from '../types.key.action';

/**
 * return an action builder to reset current selection on map
 * @type {ActionCreator<RESET_SELECTION>}
 * @since v 2.0.2
 */
export const resetSelectionCreator =
    actionCreator<RESET_SELECTION>(TypeKeyActions.RESET_SELECTION) as
    ActionCreator<RESET_SELECTION>;
/**
 * action type of resetSelectionAsyncCreator
 * @type {AsyncActionCreators<RESET_SELECTION, any, any>}
 * @since v 2.0.2
 */
export const resetSelectionAsyncCreator =
    actionCreator.async<RESET_SELECTION, Acknowledged, Error>(
        TypeKeyActions.RESET_SELECTION);
/**
 * return an action builder with a promise to reset current selection on map
 * @type {ActionCreator<RESET_SELECTION>}
 * @since v 2.0.2
 * @private
 * @hidden
 */
export const resetSelectionCreatorP =
    promiseActionCreator(resetSelectionCreator, [
      resetSelectionAsyncCreator.done.type,
      resetSelectionAsyncCreator.failed.type
    ]);
/**
 * return an action builder to add features to selection
 * @type {ActionCreator<ADD_TO_SELECTION>}
 * @since v 2.0.2
 */
export const addToSelectionCreator =
    actionCreator<ADD_TO_SELECTION>(TypeKeyActions.ADD_TO_SELECTION) as
    ActionCreator<ADD_TO_SELECTION>;
/**
 * action type of addToSelectionAsyncCreator
 * @type {AsyncActionCreators<ADD_TO_SELECTION, any, Error>}
 * @since v 2.0.2
 */
export const addToSelectionAsyncCreator =
    actionCreator.async<ADD_TO_SELECTION, Acknowledged, Error>(
        TypeKeyActions.ADD_TO_SELECTION);
/**
 * return an action builder with a promise to add features to selection
 * @type {ActionCreator<ADD_TO_SELECTION>}
 * @since v 2.0.2
 * @private
 * @hidden
 */
export const addToSelectionCreatorP =
    promiseActionCreator(addToSelectionCreator, [
      addToSelectionAsyncCreator.done.type,
      addToSelectionAsyncCreator.failed.type
    ]);
/**
 * return an action builder to remove features from selection on map
 * @type {ActionCreator<REMOVE_FROM_SELECTION>}
 * @since v 2.0.2
 */
export const removeFromSelectionCreator =
    actionCreator<REMOVE_FROM_SELECTION>(
        TypeKeyActions.REMOVE_FROM_SELECTION) as
    ActionCreator<REMOVE_FROM_SELECTION>;
/**
 * action type of resetSelectionAsyncCreator
 * @type {AsyncActionCreators<REMOVE_FROM_SELECTION, any, any>}
 * @since v 2.0.2
 */
export const removeFromSelectionAsyncCreator =
    actionCreator.async<REMOVE_FROM_SELECTION, Acknowledged, Error>(
        TypeKeyActions.REMOVE_FROM_SELECTION);
/**
 * return an action builder with a promise to remove features from selection on
 * map
 * @type {ActionCreator<REMOVE_FROM_SELECTION>}
 * @since v 2.0.2
 * @private
 * @hidden
 */
export const removeFromSelectionCreatorP =
    promiseActionCreator(removeFromSelectionCreator, [
      removeFromSelectionAsyncCreator.done.type,
      removeFromSelectionAsyncCreator.failed.type
    ]);
